module.exports = __webpack_public_path__ + "static/media/vencimiento_amarillo.c72f8db1.svg";